export const GET_TOP_TEN = 'GET_TOP_TEN';
export const SEARCH_TRACKS = 'SEARCH_TRACKS';
export const SET_LOADING = 'SET_LOADING';
export const GET_TRACK = 'GET_TRACK';
export const GET_VIDEO = 'GET_VIDEO';
export const SET_LYRICS = 'SET_LYRICS';
export const SET_SEARCH = 'SET_SEARCH';
export const SET_TOP_TEN = 'SET_TOP_TEN';
